var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f0db4f",
      fillOpacity: 1,
      stroke: "none"
    },
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#323330",
      fillOpacity: 1
    },
    d: "M64.27 53.305c-.512-3.196-2.594-5.875-8.762-8.375-2.145-.989-4.531-1.692-5.242-3.317-.254-.945-.29-1.476-.13-2.047.462-1.859 2.676-2.437 4.434-1.906 1.13.38 2.203 1.254 2.848 2.645 3.02-1.957 3.012-1.946 5.121-3.29-.77-1.195-1.184-1.75-1.687-2.261-1.817-2.031-4.293-3.074-8.25-2.996l-2.067.27c-1.972.495-3.855 1.535-4.96 2.925-3.317 3.762-2.372 10.34 1.663 13.05 3.973 2.981 9.805 3.657 10.551 6.446.727 3.414-2.508 4.52-5.723 4.125-2.367-.492-3.683-1.695-5.109-3.886-2.621 1.519-2.621 1.519-5.316 3.07.64 1.394 1.312 2.027 2.382 3.238 5.07 5.145 17.758 4.89 20.036-2.894.093-.266.703-2.047.21-4.797ZM38.055 32.172h-6.547c0 5.656-.028 11.273-.028 16.93 0 3.597.188 6.898-.398 7.91-.96 1.988-3.441 1.742-4.574 1.355-1.149-.562-1.735-1.37-2.414-2.508-.188-.324-.324-.578-.371-.597-1.778 1.086-3.547 2.175-5.325 3.261.887 1.817 2.188 3.391 3.86 4.418 2.496 1.496 5.847 1.954 9.355 1.149 2.282-.664 4.25-2.043 5.282-4.137 1.492-2.75 1.171-6.074 1.16-9.754.03-6.004 0-12.004 0-18.027Zm0 0"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.3a1e87c6e57159e6a263df65940117a7.svg";
export { ForwardRef as ReactComponent };